import authHeader from 'services/auth/jwt/auth-header';
import customAxios from './Api';

export const updateRecordModifiedDate = async siteAssessmentID => {
  try {
    await customAxios.post(
      `/CRM/EditRecordModifiedDate?siteAssessmentID=${siteAssessmentID}`,
      {},
      { headers: authHeader() },
    );
  } catch (error) {
    console.log('Failed to update record modified date', error);
  }
};
